import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from './user';
import app from './app';
import questions from './questions';
import mainpage from './mainpage';
import result from './result';
import translate from './translate';

export default combineReducers({
	router: routerReducer,
	user,
	app,
	questions,
	mainpage,
	result,
	translate,
});
